import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Brand from '../../menhomethree/Brand'
import First from '../mengallery/First'
import ComingSoon from '../comingsoon/ComingSoon'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Our Gallery"/>
        {/* <First/> */}
        <ComingSoon pageName="Our Gallery" />
        {/* <Brand/> */}
    </>
  )
}

export default Main